// Settings > Appearance is stored in localStorage and has to take effect on
// every page load, not only while the Settings page is open.
export const SETTINGS_STORAGE_KEY = 'survey-app-settings'

export type FontSize = 'small' | 'normal' | 'large'

const FONT_SIZES: Record<FontSize, string> = { small: '87.5%', normal: '', large: '112.5%' }

export function applyAppearance(a: { reducedMotion?: boolean; fontSize?: FontSize }): void {
  const root = document.documentElement
  root.classList.toggle('reduce-motion', Boolean(a.reducedMotion))
  const size = FONT_SIZES[a.fontSize ?? 'normal'] ?? ''
  if (size) root.style.setProperty('font-size', size)
  else root.style.removeProperty('font-size')
}

export function applyStoredAppearance(): void {
  try {
    const raw = localStorage.getItem(SETTINGS_STORAGE_KEY)
    if (raw) applyAppearance(JSON.parse(raw)?.appearance ?? {})
  } catch {
    // Storage blocked or bad JSON: keep the defaults.
  }
}
